import { useMutation } from 'react-query';
import { groupRequest } from 'src/models/CRM';
import { postGroup } from 'src/services/CRM/groups';

export default function AddGroup() {
  return useMutation((data: groupRequest) => postGroup(data));
}
